import { Box, Typography } from "@mui/material";
import React from "react";
import CustomTooltip from "shared/components/CustomTooltip";
import { COLOR_GREY_2, COLOR_GREY_9 } from "shared/theme/colors";
import { InfoOutlinedIcon } from "shared/theme/icons/InfoOutlinedIcon";

type ListboxComponentProps = {
  children?: React.ReactNode;
  role?: string;
  "aria-labelledby"?: string;
  ref?: React.Ref<HTMLUListElement>;
} & React.HTMLAttributes<HTMLUListElement>;

function ListboxComponent(props: ListboxComponentProps) {
  return (
    <Box position="relative">
      <Box position="absolute" top={0} right={0} zIndex={10}>
        <CustomTooltip title="Some games cannot be removed because it has been filtered by one or more tags. To remove the game either remove the tag used to filter the game or hide the visibility in the game ordering.">
          <Box
            padding="8px"
            borderRadius="0 0 0 8px"
            bgcolor={COLOR_GREY_2}
            display="flex"
            alignItems="center"
            gap="4px"
          >
            <Typography fontSize="12px" fontWeight="500" color={COLOR_GREY_9}>
              Why can't I uncheck some games?
            </Typography>
            <InfoOutlinedIcon size={16} color={COLOR_GREY_9} />
          </Box>
        </CustomTooltip>
      </Box>
      <ul {...props} style={{ paddingTop: "34px" }} />
    </Box>
  );
}

export default ListboxComponent;
